module.exports = __webpack_public_path__ + "img/unnamed.dc0d6a3f.png";